import { render, staticRenderFns } from "./ReasonsCancel.vue?vue&type=template&id=af275626"
import script from "./ReasonsCancel.vue?vue&type=script&lang=js"
export * from "./ReasonsCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports